import React, { useState } from 'react';
import { CheckCircle2 } from 'lucide-react';
import { COPY } from './copy';

// Introduce me / Not now under a partner the coach suggested (PRD §6.6).
// "Introduce me" answers the coach in the chat; he then asks for consent
// with the confirmation sheet, so nothing is shared from this button.
// The introduction status and "not now" come from the server, so the
// buttons stay right after a reload.
export default function PartnerSuggestion({ recommendation, partnerName, coachName, onIntroduce, onNotNow, disabled }) {
  const [status, setStatus] = useState(null); // 'saving' | 'error'
  const introduced = recommendation.introduction_status;

  if (introduced && !['declined', 'cancelled', 'expired'].includes(introduced)) {
    return (
      <p className="m-0 inline-flex items-center gap-1.5 text-[13px] font-medium text-teal-ink" data-testid="partner-introduced">
        <CheckCircle2 size={16} /> {COPY.introductionRequested(partnerName)}
      </p>
    );
  }
  if (recommendation.not_now) {
    return <p className="m-0 text-[13px] text-muted-foreground" data-testid="partner-not-now">{COPY.partnerNotNow(coachName)}</p>;
  }

  const notNow = async () => {
    setStatus('saving');
    try {
      setStatus((await onNotNow(recommendation)) ? null : 'error');
    } catch (e) {
      setStatus('error');
    }
  };

  return (
    <div className="flex flex-wrap items-center gap-2.5" data-testid="partner-suggestion">
      <button
        type="button"
        className="min-h-9 px-[18px] rounded-full border-0 bg-orange-cta text-white text-[13px] font-medium cursor-pointer disabled:opacity-60"
        disabled={disabled || !onIntroduce || status === 'saving'}
        onClick={() => onIntroduce(recommendation, partnerName)}
      >
        {COPY.introduceMe(partnerName)}
      </button>
      <button
        type="button"
        className="min-h-9 px-[18px] rounded-full border border-border bg-transparent text-foreground text-[13px] cursor-pointer disabled:opacity-60"
        disabled={!onNotNow || status === 'saving'}
        onClick={notNow}
      >
        {COPY.notNow}
      </button>
      {status === 'error' && <span className="w-full text-[12px] text-coral-ink">That didn't save. Please try again.</span>}
    </div>
  );
}
